type errorInitialStateType = {isFirstName:boolean ; isLastName:boolean; isFieldBlank:boolean; isEmailIncorrect:boolean; isPhoneIncorrect:boolean} 
type customerInfoType = {firstName:string ; lastName:string ; emailPhone: string}

export const errorInitialState :errorInitialStateType= {
    isFirstName: false,
    isLastName: false,
    isFieldBlank: false,
    isEmailIncorrect: false,
    isPhoneIncorrect: false

};
export const customerInfo :customerInfoType= {
    firstName: 'firstName',
    lastName: 'lastName',
    emailPhone: 'emailPhone'
};
  
export const formPlaceholder:customerInfoType = {
    firstName: 'First Name',
    lastName: 'Last Name',
    emailPhone: 'Account Email or phone number'
};
  
export const customerInitialState :customerInfoType= {
    firstName: '',
    lastName: '',
    emailPhone: ''
};
export const SubmitButtonClassVlaue: string = "base-button base-button--full-width regulatory-updates-modal__btn sj-button base-button--activation";
export const SubmitButtonDisabledClassVlaue: string = "base-button base-button--full-width regulatory-updates-modal__btn sj-button base-button--activation base-button--disabled";
